import React, { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { VideoSection } from './components/VideoSection';
import { Benefits } from './components/Benefits';
import { TemplatesSection } from './components/TemplatesSection';
import { Gallery } from './components/Gallery';
import { GuideContents } from './components/GuideContents';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    document.title = 'Deco Emprende | Falso Vitral Deco';
  }, []);
  return <div className="min-h-screen bg-deco-bg font-sans selection:bg-deco-terra selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <OfferBar data-id="element-2" />
      <main className="overflow-hidden" data-id="element-3">
        <Hero data-id="element-4" />
        <VideoSection data-id="element-5" />
        <Benefits data-id="element-6" />
        <TemplatesSection data-id="element-7" />
        <Gallery data-id="element-8" />
        <GuideContents data-id="element-9" />
        <Bonuses data-id="element-10" />
        <Testimonials data-id="element-11" />
        <PurchaseSection data-id="element-12" />
        <FAQ data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
    </div>;
}